import { useAuth } from "providers/auth"
import { ReactNode, createContext } from "react"

type PermissionContextProps = {
  isAllowedTo: (
    permission: string | string[],
    type: "permissions" | "groups" | "modules" | "services"
  ) => boolean | undefined
}

const defaultBehaviour: PermissionContextProps = {
  isAllowedTo: () => false,
}

export const PermissionContext =
  createContext<PermissionContextProps>(defaultBehaviour)

const PermissionProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const { user } = useAuth()

  const isAllowedTo = (
    restriction: string | string[],
    type: "permissions" | "groups" | "modules" | "services"
  ) => {
    // if has role super_admin skip permissions checks
    if (user?.roles?.includes("super_admin")) return true
    // check if has permission
    if (type === "permissions") {
      if (typeof restriction === "string") {
        return user?.permissions?.includes(restriction)
      } else {
        return restriction.some((element) =>
          user?.permissions?.includes(element)
        )
      }
    }
    if (typeof restriction === "string") {
      return user?.accesses?.[type].includes(restriction)
    }
  }

  return (
    <PermissionContext.Provider value={{ isAllowedTo }}>
      {children}
    </PermissionContext.Provider>
  )
}

export default PermissionProvider
